<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        关于大连海大智龙科技有限公司作为第1完成单位参与的“基于人工智能的船舶智能货物管理系统”项目拟申报2021年大连市高层次人才创新支持计划研发项目的公示
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2021-04-08</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row div-bottom10">
        <p class="indentation">
          根据《中共大连市委办公室
          大连市人民政府办公室印发〈关于落实“5+22”人才政策的几个具体问题〉及31个配套实施细则的通知》（大委办发〔2019〕19号）及《大连市高层次人才创新支持计划研发项目资助实施细则》，现将大连海大智龙科技有限公司作为第1完成单位申报的大连市高层次人才创新支持计划研发项目——“基于人工智能的船舶智能货物管理系统”予以公示。
          自即日起5日内，任何单位或个人对公示项目的创新性、先进性、实用性及推荐材料的真实性和项目主要完成人、主要完成单位及排序持有异议的，可以书面形式向大连海大智龙科技有限公司提出，并提供必要的证明材料。为便于核实查证，确保实事求是、客观公正地处理异议，提出异议的单位或者个人应当表明真实身份，并提供联系方式。凡匿名异议和超出期限的异议，不予受理。
          特此公示。
        </p>
        <p class="indentation">
          通讯地址：辽宁省大连市高新技术产业园区黄浦路523号海事科技大厦A座11层
        </p>
        <p class="indentation">
          联系电话：0411-84978997
        </p>
        <p class="indentation" style="text-align:right;">
          大连海大智龙科技有限公司<br/>
          2021年4月6日
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2021/news23.vue